import React from "react"

const IconHamburger = props => (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M1 12H19C19.55 12 20 12.45 20 13C20 13.55 19.55 14 19 14H1C0.45 14 0 13.55 0 13C0 12.45 0.45 12 1 12ZM1 6H19C19.55 6 20 6.45 20 7C20 7.55 19.55 8 19 8H1C0.45 8 0 7.55 0 7C0 6.45 0.45 6 1 6ZM1 0H19C19.55 0 20 0.45 20 1C20 1.55 19.55 2 19 2H1C0.45 2 0 1.55 0 1C0 0.45 0.45 0 1 0Z" fill="currentColor" />
  </svg>
)

export default IconHamburger
